import ContentLink from './ContentLink'
// Uncomment the below to migrate to stateful component
// import ContentLinkContainer from './ContentLinkContainer'

export { ContentLink }
export default ContentLink
// Uncomment the below to migrate to stateful component
// export { ContentLinkContainer }
// export default { ContentLinkContainer }
